import { render } from "./GravisTwoView.vue?vue&type=template&id=3046e165"
import script from "./GravisTwoView.vue?vue&type=script&lang=js"
export * from "./GravisTwoView.vue?vue&type=script&lang=js"

import "./GravisTwoView.vue?vue&type=style&index=0&id=3046e165&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__